import { styled } from '@mui/material/styles';

import ChakraButton from '~/common/components/Buttons/Button/index';
import theme from '~/theme/';

export const StyledLinkButton = styled<any>(ChakraButton)`
  font-size: 1rem;
  &:active,
  &:focus,
  &:hover {
    outline: none;
    box-shadow: none; /* Remove any box-shadow that might be causing the outline */
    text-decoration: underline;
  }
`;

export const StyledExtractionDataIconPseudoButton = styled<any>('div')(
  ({ padding, isInline, margin }) => ({
    padding: padding,
    color: isInline ? theme.colors.white : theme.colors.blue[600],
    height: isInline ? '1rem' : '1.5rem',
    width: isInline ? '1rem' : '1.5rem',
    minWidth: isInline ? '1rem' : '1.5rem',
    minHeight: isInline ? '1rem' : '1.5rem',
    fontSize: '0.6rem',
    lineHeight: '1rem',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '.25rem',
    margin: isInline ? '0' : margin,

    backgroundColor: isInline ? theme.colors.blue[600] : 'transparent',
  }),
);
